export default "__VITE_ASSET__DCKkLa_h__"